<template>
  <default-layout>
    <home-hero/>
    <b-container class="my-3 py-4">
      <div class="text-center mb-3">
        <h2 class="h3">Available in {{ currentRegion.name }}</h2>
      </div>
      <category-thumbnails/>
    </b-container>
    <b-container fluid class="p-0">
      <home-buy-sell/>
    </b-container>
    <b-container>
      <home-about/>
    </b-container>
  </default-layout>
</template>

<script>
import { mapGetters } from 'vuex'
import CategoryThumbnails from '@/components/listings/CategoryThumbnails.vue'
import HomeAbout from '@/components/home/HomeAbout.vue'
import HomeBuySell from '@/components/home/HomeBuySell.vue'
import HomeHero from '@/components/home/HomeHero.vue'

export default {
  name: 'Home',
  components: {
    CategoryThumbnails,
    HomeAbout,
    HomeBuySell,
    HomeHero,
  },
  computed: {
    ...mapGetters('Region', { currentRegion: 'current' }),
  },
}
</script>
